import { formatDate, formatePrice } from "../utils/utils";

const columns = [
    {
        title: 'Symbol',
        dataIndex: 'symbolName',
    },
    {
        title: 'Type',
        dataIndex: 'buySell',
        render: (text) => text === 'Buy' ? <span className="text-[#28C76F] bg-[#DDF6E8] p-1 px-2 rounded font-semibold">Buy</span> : <span className="text-[#FF4C51] bg-[#FFE2E3] p-1 px-2 rounded font-semibold">Sell</span>,
    },
    {
        title: 'Volume',
        dataIndex: 'amount',
    },
    {
        title: 'Open Price',
        dataIndex: 'openPrice',
        render: (text) => formatePrice(text),
        width: 150,
    },
    {
        title: 'Current Price',
        dataIndex: 'currentPrice',
        render: (text) => formatePrice(text),
        width: 150,
    },
    {
        title: 'S/L',
        dataIndex: 'stopLoss',
        render: (text) => formatePrice(text),
    },
    {
        title: 'T/P',
        dataIndex: 'takeProfit',
        render: (text) => formatePrice(text),
    },
    // {
    //     title: 'Swap',
    //     dataIndex: 'Swap',
    //     render: (text) => formatePrice(text),
    // },
    {
        title: 'Open Time',
        dataIndex: 'dateTime',
        render: (text) => formatDate(text),
    },
    {
        title: 'P/L',
        dataIndex: 'profitLoss',
        render: (text) => text > 0 ? <span className="text-[#28C76F] font-semibold">{formatePrice(text)}</span> : <span className="text-[#FF4C51] font-semibold">{formatePrice(text)}</span>,
        width: 120,
    },
];

export default columns;